const errors = {
  'error.default.retry.title': 'Oops something went wrong...',
  'error.default.retry.message': 'There could be a problem with your connection, check your connection and click retry.',

  'error.default.logout.title': 'Oops something went wrong...',
  'error.default.logout.message': 'You will need to be logged out to fix this problem.',

  'error.default.message_only.title': 'Oops something went wrong...',
  'error.default.message_only.message': 'You will need to login again',

  'error.default.go_back.title': 'Oops something went wrong...',
  'error.default.go_back.message': 'An issue occurred with your current action.',

  'error.default.reset.title': 'Oops something went wrong...',
  'error.default.reset.message': 'You will need to login again',

  'error.feature.available-on-mobile.title': 'Please use the mobile app',
  'error.feature.available-on-mobile.message': 'This feature is not available at this time, please use the mobile app.'
}

export default errors;

